import PhotoGallery from "../Layout/PhotoGallery";
import PhotoGalleryHandler from "../Analytics/Handlers/PhotoGalleryHandler";

export default (window, analyticsManager) => {
    let galleryCountOffset = 0;
    Array.from(window.document.querySelectorAll("[data-lazy-module=photoGallery]"))
        .map((node, num) => {
            galleryCountOffset = galleryCountOffset || parseInt(node.getAttribute("data-gallery-is-header"), 10);
            return new PhotoGallery(node, { position: num + 1 - galleryCountOffset });
        });

    analyticsManager.addHandlers([new PhotoGalleryHandler()]);
};

